import * as _ from "lodash";
import http from "../constant/api";

export const profileService = {
  getListProfile: async (filter) => {
    const status = _.get(filter, "status");
    const search = _.get(filter, "search");

    const query = {};
    if (!_.isNil(status)) {
      query.status = status;
    }
    if (search) {
      query.search = search;
    }

    const result = await http.get("/api/profile/list", { params: query });

    return result;
  },
  readProfile: async (id) => {
    const result = await http.get(`/api/profile/${id}/read`);

    return result;
  },
  readProfileByDomain: async (domain) => {
    const result = await http.get(
      `/api/profile/read/domain/${encodeURIComponent(domain)}`
    );

    return result;
  },
  readProfileByDomainWidget: async (domain) => {
    const result = await http.get(
      `/api/profile/read/domain/${encodeURIComponent(domain)}/widget`
    );

    return result;
  },
  addProfile: async (data, isFormData = false) => {
    const result = await http.post(`/api/profile/add`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });

    return result;
  },
  editProfile: async (id, data, isFormData = false) => {
    const result = await http.put(`/api/profile/${id}/edit`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    });

    return result;
  },
  removeProfile: async (id) => {
    const result = await http.delete(`/api/profile/${id}/remove`);

    return result;
  },
  getProfileAllowed: async () => {
    const result = await http.get(`/api/profile/list/allowed`);

    return result;
  },
  getListTimeZone: async () => {
    const result = await http.get(`/api/profile/time-zone/list`);

    return result;
  },
};
